import { useTheme } from 'next-themes'
import { Toaster as Sonner, toast } from 'sonner'

const errorSetRef = new Set() // Lưu các lỗi đã hiển thị trong 2 giây
const successSetRef = new Set() // Lưu các lỗi đã hiển thị trong 2 giây

// Hàm xử lý lỗi, tránh spam toast lỗi trùng lặp
const showErrorToast = (message, options = {}) => {
  if (errorSetRef.has(message)) return // Nếu lỗi đã hiển thị, bỏ qua

  toast.error(message, options) // Hiển thị toast lỗi
  errorSetRef.add(message) // Lưu vào Set

  setTimeout(() => {
    errorSetRef.delete(message) // Xóa sau 2 giây để hiển thị lại nếu cần
  }, 2000)
}
const showSuccessToast = (message, options = {}) => {
  if (successSetRef.has(message)) return

  toast.success(message, options)
  successSetRef.add(message)

  setTimeout(() => {
    successSetRef.delete(message)
  }, 2000)
}

const showInfoToast = (message, options = {}) => {
  if (successSetRef.has(message)) return

  toast.info(message, options)
  successSetRef.add(message)

  setTimeout(() => {
    successSetRef.delete(message)
  }, 2000)
}

const Toaster = ({ ...props }) => {
  const { theme = 'system' } = useTheme()
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { Toaster, showErrorToast, showSuccessToast, showInfoToast }
